export default "__VITE_ASSET__zZcHImK$__"